import { Box, Container } from "@mui/material";
import React from "react";
import LoginBanner from "./LoginBanner";
import LoginForm from "./LoginForm";
import FlagBg from "../../../assets/images/flag_matrix_bg.jpg";
import EmailLoginForm from "./EmailLoginForm";

function LoginScreen({
  emailLogin = false,
}) {
  return (
    <Container
      maxWidth={"xxl"}
      sx={{
        padding: "0px !important",
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        height: {
          xs: "150vh",
          md: "100vh",
        },
        width: "100vw",
      }}
    >
      <Box
        sx={{
          background: `url(${FlagBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          width: {
            xs: "calc(100% - 40px)",
            md: "60%",
          },
          p: {
            xs: "100px 20px",
            md: "0px",
          },
          height: "100%",
          boxShadow: "40px 0px 50px rgba(197, 229, 255, 0.25)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <LoginBanner />
      </Box>
      <Box
        sx={{
          width: {
            xs: "100%",
            md: "40%",
          },
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!emailLogin && <LoginForm />}
        {emailLogin && <EmailLoginForm />}
      </Box>
    </Container>
  );
}

export default LoginScreen;
